import React, { FC } from 'react';
import { 
    StyleSheet,
    StatusBar, 
    View
} from "react-native";

// import LinearGradient from 'react-native-linear-gradient';
import Colors from '../../constants/Colors'

interface IProps {
    noPadding?: boolean
}

const HeaderGradient: FC<IProps> = ({ children, noPadding }) => {
    return (
        // <LinearGradient
        //     colors={[Colors.tintColor, Colors.tintColor]}
        //     // colors={[Colors.tintColor, '#23CBFD']}
        //     useAngle={true}
        //     angle={90}
        //     angleCenter={{ x: 0.5, y: 0.5 }}
        //     style={[
        //         styles.gradientContainer,
        //         {
        //             paddingTop: noPadding ? 0 : StatusBar.currentHeight,
        //         }
        //     ]}
        // >
        //     {children}
        // </LinearGradient>
        <View
            style={[
                styles.gradientContainer,
                {
                    paddingTop: noPadding ? 0 : StatusBar.currentHeight,
                }
            ]}
        >
            {children}
        </View>
    )
}

export default HeaderGradient

const styles = StyleSheet.create({
    gradientContainer: {
        elevation: 2,
        marginVertical: 0,
        paddingVertical: 0,
        backgroundColor: Colors.tintColor
    },
})